// Centralized WhatsApp/Tintim link for all CTAs
export const WHATSAPP_LINK = "https://tintim.link/whatsapp/17a36622-1367-4e5e-a0a8-901d5181a4f3/94283f51-f5ca-4554-80be-e95b4a777d6a";
